import React, { PureComponent } from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';

import {booleanConvert, stableSort, getSorting, insertIf} from '../helpers';
import EnhancedTableHead from '../TableHead/EnhancedTableHead';
import ModalBox from '../Modals/ModalBox';
import Search from '../Search/Search';

import './style.css';

import { API } from '../../../ws/constants';

var moment = require('moment');

export class Notes extends PureComponent {
    date = moment();
    state = {
        fetchData:null
        , openModal:false
        , order:'asc'
        , orderBy:'DateCreated'
        , page:0
        , rowsPerPage:10
        , tableLoading:false
    };

    componentWillMount() {
        const onlyShowActive = this.props.isAdmin || this.props.loginData.profile.Notepad.isActive ? "" : "&onlyactive=true";
        this.setState({ tableLoading:true });

        fetch(API + "getnotes&categoryid="+this.props.categoryId + onlyShowActive)
        .then(response => response.json())
        .then(data => this.setState({ fetchData: data, tableLoading:false }));
    }

    componentDidUpdate(prevProps) {
        if(this.props.categoryId && prevProps.categoryId !== this.props.categoryId){
            const onlyShowActive = this.props.isAdmin || this.props.loginData.profile.Notepad.isActive ? "" : "&onlyactive=true";
            this.setState({ tableLoading:true });
    
            fetch(API + "getnotes&categoryid="+this.props.categoryId + onlyShowActive)
            .then(response => response.json())
            .then(data => this.setState({ fetchData: data, tableLoading:false }));
        }
    }

    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value });
    handleSelectChange = (e) => this.setState({ [e.target.name]: e.target.value });
    handleToggle = (e, value) => this.setState({ [e.target.id]: value ? "1" : "0" });

    handleDelete = (e) => {
        if(window.confirm("Tem a certeza que quer apagar esta nota?")){
            const onlyInactivate = this.props.isAdmin || this.props.loginData.profile.Notepad.isActive ? "" : "&inactivate=true";
            const noteId = e.currentTarget.dataset.noteId;
            this.setState({ loading:true });
            fetch(API + 'deletenote&noteid=' + noteId + onlyInactivate + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                const newFetchData = {...this.state.fetchData};
                newFetchData.data = newFetchData.data.filter(x => x.Id !== noteId);
                this.setState({ fetchData: newFetchData, returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, loading:false });
            });
        }
    }

    handleSearch = (search) => {
        const onlyShowActive = !this.props.isAdmin ? "&onlyactive=true" : "";
        this.setState({ tableLoading:true, page: 0 });
        fetch(API + "searchnotes&keyword="+search+"&categoryid="+this.props.categoryId + onlyShowActive)
        .then(response => response.json())
        .then(data => this.setState({ fetchData: data, tableLoading:false }));
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    openModal = (textObj) => {
        this.setState({ returnTitle: textObj.title, returnText: textObj.text , openModal: true });
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
    }

    renderSegmentationResults = () => {
        const segmentationResults = this.state.segmentationResults;
        const elements = [];

        for(let i=0,n=segmentationResults.length;i<n;i++){
            const thisResult = segmentationResults[i];
            elements.push(<p key={`${i}_${thisResult.Id}`}>Nome: {thisResult.ClientFirstName} {thisResult.ClientLastName} - Telefone: {thisResult.ClientPhoneNumber} - Email: {thisResult.ClientEmail}</p>);
        }

        return elements;
    }

    render() {
        const { isAdmin, loginData, categoryName, categoryId, newNotes } = this.props;
        const notes = this.state.fetchData!=null ? this.state.fetchData.data : []
              , loadingClass = this.state.tableLoading ? " ajaxLoading" : ""
              , { order, orderBy, rowsPerPage, page } = this.state
              , headerRows = [
                  { id: 'Author', numeric: false, label: 'Autor' },
                  { id: 'Name', numeric: false, label: 'Designação' },
                  ...insertIf(isAdmin || loginData.profile.Notepad.isActive, { id: 'DeactivatedBy', numeric: false, label: 'Desativada por' }),
                  ...insertIf(!isAdmin && !loginData.profile.Notepad.isActive, { id: 'Note', numeric: false, label: 'Resumo' }),
                  { id: 'DateCreated', numeric: false, label: 'Data' },
                  ...insertIf(isAdmin || loginData.profile.Notepad.isActive, { id: 'IsActive', numeric: false, className: 'smallerHeader', label: 'Ativo' }),
                  { id: 'actions', notSortable: true, label: 'Ações' },
              ];

        return (
            <div id="notesPage">
                <div>
                    <div className="row">
                        <Search searchCallback={this.handleSearch}
                                className="col-12 col-md-4"/>
                    </div>
                    <div className="pageHeader">
                        <h1>
                            <i className="fas fa-book-open"></i> Notas de {categoryName} <span className="arrayCount">({notes.length})</span>
                            { (isAdmin || loginData.profile.Notepad.ADD) && 
                                <span className="float-right">
                                    <Tooltip
                                        title={"Adicionar Nota de " + categoryName}
                                        enterDelay={200}>
                                        <span><button className="actionButton success" data-cat-id={categoryId} onClick={this.props.onAddNewNote}><i className="fa fa-plus"></i></button></span>
                                    </Tooltip>
                                </span>
                            }
                        </h1>
                    </div>
                    <Table className={"responsiveTable customTable" + loadingClass}>
                        <EnhancedTableHead
                            className="tableRow tableHeader"
                            headerRows={headerRows}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                            rowCount={notes.length}>
                        </EnhancedTableHead>
                        <TableBody>
                            {stableSort(notes, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(note => {
                                    const isNewNote = newNotes.find(x => x.Id === note.Id);
                                    return (<TableRow key={note.Id} className="tableRow" ref={"noteId_" + note.Id}>
                                        <TableCell data-title="Autor" className="tableCell midCell">{note.Author}</TableCell >
                                        <TableCell data-title="Designação" className="tableCell">
                                            <Tooltip
                                                title={note.Name}
                                                enterDelay={200}>
                                                <span className="noteNameHolder">
                                                    {Boolean(isNewNote) && <span className="newNotes">n</span>}
                                                    <button className="linkButton" data-note-id={note.Id} onClick={this.props.onEditNote}>{note.Name}</button>
                                                </span>
                                            </Tooltip>
                                        </TableCell>
                                        {(isAdmin || loginData.profile.Notepad.isActive) ? <TableCell data-title="Desactivada por" className="tableCell">{note.DeactivatedBy || "---"}</TableCell>
                                            : <TableCell data-title="Resumo" className="tableCell"><div className="note">{note.Note.replace(/(<([^>]+)>)/gi, "")}</div></TableCell>}
                                        <TableCell data-title="DateCreated" className="tableCell">{note.DateCreated}</TableCell>
                                        {(isAdmin || loginData.profile.Notepad.isActive) && <TableCell data-title="Ativo" className="tableCell smallerCell">{booleanConvert(note.IsActive)}</TableCell>}
                                        <TableCell data-title="Ações" className="tableCell actions" data-row-id={note.Id}>
                                            {(isAdmin || loginData.profile.Notepad.permission === 1) &&
                                                <Tooltip
                                                    title={"Editar Nota"}
                                                    enterDelay={200}>
                                                    <span><button className="actionButton warning" data-note-id={note.Id} onClick={this.props.onEditNote}><i className="fa fa-pencil-alt"></i></button></span>
                                                </Tooltip>
                                            }
                                            {loginData.profile.Notepad && loginData.profile.Notepad.permission === 2 &&
                                                <Tooltip
                                                    title={"Ver Notas"}
                                                    enterDelay={200}>
                                                    <span><button className="actionButton success" data-note-id={note.Id} onClick={this.props.onEditNote}><i className="fa fa-eye"></i></button></span>
                                                </Tooltip>
                                            }
                                            {(isAdmin || loginData.profile.Notepad.DEL) &&
                                                <Tooltip
                                                    title={"Eliminar Nota"}
                                                    enterDelay={200}>
                                                    <span><button type="button" className="simpleBtn actionButton danger" data-note-id={note.Id} onClick={this.handleDelete}><i className="fa fa-times"></i></button></span>
                                                </Tooltip>
                                            }
                                        </TableCell>
                                    </TableRow>)
                                }
                            )}
                        </TableBody>
                    </Table>
				</div>
                <div className="row">
                    <div className="col-12">
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={notes.length}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage="Linhas por página:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            page={page}
                            backIconButtonProps={{
                                'aria-label': 'Página anterior',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Próxima página',
                            }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} noOverlay={true} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}
